export default {
    autoBind: {
        type: Boolean,
        default: undefined
    }, 
    buttonCount: {
        type: Number,
        default: undefined
    }, 
    dataSource: {
        type: [Object, Array],
        default: undefined
    }, 
    selectTemplate: {
        type: String,
        default: undefined
    }, 
    linkTemplate: {
        type: String,
        default: undefined
    }, 
    info: {
        type: Boolean,
        default: undefined
    }, 
    input: {
        type: Boolean,
        default: undefined
    }, 
    numeric: {
        type: Boolean,
        default: undefined
    }, 
    pageSizes: {
        type: [Boolean, Array],
        default: undefined
    }, 
    previousNext: {
        type: Boolean,
        default: undefined
    }, 
    refresh: {
        type: Boolean,
        default: undefined
    }, 
    responsive: {
        type: Boolean,
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 

    // Events
    change: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-listview-vue-wrapper/src/KendoPager/PagerProps.js